import { render, staticRenderFns } from "./TitleSub.vue?vue&type=template&id=4a1560f4&scoped=true&"
import script from "./TitleSub.vue?vue&type=script&lang=js&"
export * from "./TitleSub.vue?vue&type=script&lang=js&"
import style0 from "./TitleSub.vue?vue&type=style&index=0&id=4a1560f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1560f4",
  null
  
)

export default component.exports